import React from 'react';

const Text = ({text}) => (
  <span
    dangerouslySetInnerHTML={{__html: text.replaceAll('\n', '<br/>')}}
  />
);

export default Text;
